import { IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { takeEvery, put } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import { EXPORT_BANK_TRANSACTIONS_SUCCESS, EXPORT_BANK_TRANSACTIONS_FAILURE } from './actions'

export function* exportBankTransactions() {
  yield takeEvery(
    EXPORT_BANK_TRANSACTIONS_SUCCESS,
    function* (action: IFileDownloadResponse & Action) {
      try {
        const fileName = action.data.name
        yield download(action.data, fileName)
      } catch (error: unknown) {
        yield put({ type: EXPORT_BANK_TRANSACTIONS_FAILURE, error })
      }
    },
  )
}
